module.exports = __webpack_public_path__ + "img/item(20).72d51c80.svg";